import { FinalRoutes } from './routes'
import { BrowserRouter } from 'react-router-dom'

function App() {
  return (
    <BrowserRouter>
      <FinalRoutes />
    </BrowserRouter>
  )
}

export default App
